
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { type ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class ConfirmModal extends Vue {
  options: ConfirmModalOptions | null = null
  visible: boolean = false

  model: {
    resolve: (value: unknown) => void
  } = {
    resolve: () => {}
  }

  handleCancel() {
    this.options!.onCancel?.()
    this.model.resolve(false)
    this.hide()
  }

  handleConfirm() {
    this.options!.onOk?.()
    this.model.resolve(true)
    this.$emit('confirmed')
    if (this.options!.confirmedHide === true) {
      this.hide()
    }
  }

  show(options: ConfirmModalOptions) {
    return new Promise((resolve, reject) => {
      if (!options) reject('options is required')

      this.model = {
        resolve
      }
      this.options = options
      this.visible = true
    })
  }

  hide() {
    this.visible = false
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
